export default __webpack_public_path__ + "static/lavaggio_moquette-bd331dfe588d1f3e4c39ed30a3ff6ed6.png";